import {apiService} from '../apiService';

export const addressService = apiService.injectEndpoints({
    endpoints: (builder) => {
        return {
            getAddress: builder.query({
                query: (postcode) => ({
                    url: `/address/lookup?postcode=${postcode}`
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve profile information'}),
            })
        };
    },
});

export const {
    useGetAddressQuery,
    useLazyGetAddressQuery,
} = addressService;
